import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import Reviews from './pages/Reviews';
import Admin from './pages/Admin';
import NotFound from './pages/NotFound';
import { Privacy, Terms } from './pages/Legal';
import ScrollToTop from './components/ScrollToTop';
import StickyMobileCta from './components/StickyMobileCta';
import PageTransition from './components/PageTransition';
import Analytics from './components/Analytics';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Analytics />
      <div className="App">
        <Navbar />
        <PageTransition>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/reviews" element={<Reviews />} />
            {/* Operator dashboard. Path is intentionally non-obvious
                ("/manage", not "/admin") so common bot scans that
                brute-force /admin / /wp-admin / /administrator hit
                a generic 404 instead of finding the login form. The
                404 is the correct response for those URLs — anyone
                trying to access them shouldn't get a hint that an
                admin route exists at all. */}
            <Route path="/manage" element={<Admin />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageTransition>
        <Footer />
        <StickyMobileCta />
      </div>
    </Router>
  );
}

export default App;
